var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-cover bg-center text-white pt-10 pb-12 h-64 lg:h-420px",
      style: { backgroundImage: "url(" + _vm.mastheadImage + ")" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-wrap items-center max-w-2xl m-auto px-10 mb-0 md:mb-10 justify-between",
        },
        [
          _c("div", { staticClass: "mb-10" }, [
            _c(
              "a",
              {
                staticClass:
                  "router-link-active font-light tracking-wide text-lg flex flex-col text-white no-underline",
                attrs: { href: "/" },
              },
              [_c("ReimaginePortalIcon", { attrs: { responsive: "" } })],
              1
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex max-w-2xl m-auto pt-0 lg:pt-24 pb-2" }, [
        _c("div", { staticClass: "w-full h-full md:w-3/5" }, [
          _c(
            "h1",
            { staticClass: "mb-3 text-4.5xl md:text-5xl leading-tight pl-4" },
            [_vm._v("\n        " + _vm._s(_vm.heading) + "\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass:
          "self-start text-base sm:text-xl no-underline text-white font-light",
        attrs: {
          target: "_blank",
          href: "https://help.letsreimagine.org/hc/en-us/sections/360008463452-Creating-Your-Account-and-Public-Profile",
        },
      },
      [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v("(opens in a new tab)"),
        ]),
        _vm._v(" Help Center\n    "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }